import axios from "axios";
import Cookies from "js-cookie";
import { ARTICLE_FILTER_LIST_API_URL } from "lib/constants";
import type {
  ArticleListRequestQuery,
  ArticleListResponse,
  ArticleList,
} from "lib/types/article";

export const getArticlesByPage = async (
  params: ArticleListRequestQuery,
  url = "/api/content/articles"
) => {
  return await axios
    .get<ArticleListResponse>(url, { params })
    .then((res) => res.data);
};

export const fetchArticles = async (
  params: ArticleListRequestQuery,
  url = ARTICLE_FILTER_LIST_API_URL
): Promise<ArticleListResponse> => {
  const result = await axios
    .get<ArticleList>(url, {
      params,
    })
    .then((res) => {
      return {
        data: res.data,
        notFound: false,
        error: null,
      };
    })
    .catch<ArticleListResponse>((error) => {
      if (error?.response?.status === 404) {
        return { notFound: true };
      }
      return { error: error?.response?.status };
    });

  return { data: result.data, ...result };
};

export interface GiftTokenIssueResponse {
  token: string;
  pathWithToken: string;
  remainingAllowance: number | string;
  nextCycleExpiry: string | null;
}

export interface GiftTokenStateResponse {
  nextCycleExpiry: string | null;
  remainingAllowance: number | string;
}

export const issueGiftToken = async (
  articlePath: string
): Promise<GiftTokenIssueResponse> => {
  const session = Cookies.get("blaize_session");

  const response = await axios.post<GiftTokenIssueResponse>(
    "/plugins/user/public/token-gifts/issue",
    {
      path: articlePath,
    },
    {
      headers: {
        "Content-Type": "application/json",
        ...(session && { session }),
      },
    }
  );
  return response.data;
};

export const getGiftTokenState = async (): Promise<GiftTokenStateResponse> => {
  const session = Cookies.get("blaize_session");

  const response = await axios.get<GiftTokenStateResponse>(
    "/plugins/user/public/token-gifts/state",
    {
      params: {
        ...(session && { session }),
      },
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};
